/*!
 * slxControls v1.0.6 (http://selerix.com)
 * Copyright 2017 Selerix Systems, Inc. All Rights Reserved.
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 *
 * Dependencies: jQuery v1.10+, Bootstrap v3.2+, polyfills.js
 */
(function () {
	'use strict';
	var x = window.SlxControl;

	/*
	 * slx.progressBar
	 * Dependencies: slx.core
	 */
	x.slx.progressBar = function progressBar(el) {
		var that = this;
		x.slx.base.apply(that, arguments);

		el = that._element;
		if (el === void 0) { return this; }
		else if (el.length === 0) { return el; }

		that.id = that.id || el.slxUniqueId();
		that.selector = '#' + that.id;

		that._ord = el.data('progress-order');
		if (typeof (that._ord) === 'string') { that._ord = that._ord.replaceAll(' ', '').split(','); }

		that.progressOrder = that.progressOrder || that._ord || ['default', 'success', 'info', 'warning', 'danger'];
		that.progressBars = that.progressBars || [];
		that.container = x(that.selector + '_container');
		that.onChange = that.onChange || el.attr('onchange') !== void 0 ? new Function(el.attr('onchange').replace('javascript:', '')) : null;
		that.overlays = that.overlays !== void 0 ? that.overlays : el.data('overlays') !== void 0 ? el.data('overlays') : true;
		that.tooltips = that.tooltips !== void 0 ? that.tooltips : el.data('tooltips') !== void 0 ? el.data('tooltips') : true;
		that.tooltipPlacement = that.tooltipPlacement || el.data('tooltip-placement') || 'top';
		that.active = that.active || el.data('active') || false;

		delete that._ord;

		that.value = function (i, v) {
			v = arguments.length === 1 ? i : v;
			i = arguments.length <= 1 ? 0 : i;

			var b = that.progressBars[i];
			if (arguments.length === 0) { return b.value; }
			b.value = v;

			if (that.progressBars.length === 0) return el.jqVal.apply(el, arguments);

			var bar = el.children('.progress-bar:eq(' + i + ')');
			var ischange = bar.aria('valuenow') !== v;

			var w = (b.value / b.max) * 100;
			var txt = parseInt(w) + '%';
			bar.aria('valuenow', v).css({ width: w + '%' });
			if (that.tooltips) { bar.attr('data-original-title', txt); }
			if (ischange) {
				if (that.overlays) { that.text(i, txt); }
				el.trigger('change');
			}
		};
		that.text = function (i, v) {
			v = arguments.length === 1 ? i : v;
			i = arguments.length <= 1 ? 0 : i;

			var b = that.progressBars[i];
			if (arguments.length === 0) { return b.text; }
			b.text = v;

			var bar = el.children('.progress-bar:eq(' + i + ')');
			return bar.jqText(v);
		};
		that.progress = function (i) {
			i = i || 0;
			if (that.progressBars.length <= i) { return {}; }
			return that.progressBars[i];
		};
		that.total = function (n) {
			var t = 0;
			n = n === void 0 ? that.progressBars.length - 1 : n;
			for (var i = 0; i < n; i++) {
				var p = that.progress(i).value;
				t += p >= 0 ? p : 0;
			}
			return t;
		};

		//that.poll = function (q, callback) {
		//	q = q || '';
		//	if (that.service !== null) {
		//		var request = x.ajax({
		//			url: that.service,
		//			data: JSON.stringify({ query: q || '' }),
		//			dataType: 'JSON',
		//			cache: false,
		//			type: 'POST',
		//			processData: true,
		//			contentType: 'application/json',
		//			async: false,
		//			success: function (result) {
		//				that.progressBars = result || [];
		//				el.trigger('progress');
		//				if (typeof (callback) === 'function') { callback(that.progressBars); }
		//			},
		//			error: function (err, textStatus) { console.log(err.responseText); }
		//		});
		//	} else { el.trigger('progress'); }
		//};

		/* initialization */
		(function () {
			if (that.container.length === 0) {
				el.wrap(x('<DIV/>').attr('id', that.id + '_container').attr('data-target', that.selector).addClass('slx-progress-container'));
				that.container = x(that.selector + '_container');
			}
			if (!el.hasClass('slx-progress')) { el.addClass('slx-progress'); }
			if (!el.hasClass('progress')) { el.addClass('progress'); }

			var i, p, d, a;
			for (i = 0; i < that.progressOrder.length; i++) {
				p = that.progressOrder[i], d = p === 'default' ? 'value' : p, a = p === 'default' ? that.active : el.data(p + '-active') || false;
				if (el.data(d) !== void 0) {
					that.progressBars.push({ theme: p, value: el.data(d), text: el.data(p+'-text'), active: a });
				}
			}
			if (that.progressBars.length === 0) {
				that.progressBars.push({ theme: 'default', value: el.data('value'), text: el.data('default-text'), active: that.active });
			}

			for (i = 0; i < that.progressBars.length; i++) {
				var bar = that.progressBars[i];
				bar.theme = bar.theme || 'default';
				bar.value = bar.value || 0;
				bar.text = bar.value || '';
				bar.min = bar.min || 0;
				bar.max = bar.max || 100;
				bar.active = bar.active || false;

				var w = (bar.value / bar.max) * 100;
				bar.text = parseInt(w) + '%';
				p = x('<DIV/>').addClass('progress-bar').addClass('progress-bar-' + bar.theme).aria('valuenow', bar.value).aria('valuemin', bar.min).aria('valuemax', bar.max);
				if (bar.active) { p.addClass('progress-bar-striped active'); }
				p.css({ width: w + '%' });
				el.append(p);

				if (that.overlays) { p.text(bar.text); }
				if (that.tooltips) {
					p.attr('data-toggle', 'tooltip').attr('data-placement', that.tooltipPlacement).attr('title', bar.text);
					p.tooltip();
				}
			}

			if (that.toString() === '[progressBar]') { setTimeout(function () { el.trigger(x.Event('render')); }, 0); }
		})();

		/* events */
		(function () {
			el.off('change.slx.pb').on('change.slx.pb', function (event) {
				if (that.onChange !== null && typeof (that.onChange) === 'function') { that.onChange(); }
			});
		})();

		el[0].slxProgressBar = this;
		el[0].isSlxControl = true;

		return el;
	};
	x.slx.progressBar.prototype = Object.create(x.slx.base.prototype);
	x.slx.progressBar.prototype.constructor = x.slx.progressBar;

	/* jQuery extenders */
	x.fn.extend({
		slxProgressBar: function () {
			var slx = this.slxControl('slxProgressBar', arguments) || new x.slx.progressBar(this, arguments);
			if (arguments.length > 0) {
				var arg = arguments[0], args = Array.prototype.slice.call(arguments, 1);
				if (typeof arg === 'string' && slx.hasOwnProperty(arg)) { return typeof slx[arg] === 'function' ? slx[arg].apply(slx, args) : slx[arg]; }
				else if (typeof arg !== 'string') { x.extend(slx, arg); }
			}
			return this;
		}
	});
	x(function () { x('.slx-progress').each(function () { x(this).slxProgressBar(); }); });

	return x;
})();